import './scss/style.scss';
import MLC3D from './js/mlc3d';
import gsap from "gsap";
import $ from 'jquery';
import Swipe from './js/swipe.js';
//import '@fancyapps/fancybox/dist/jquery.fancybox';
//import '@fancyapps/fancybox/dist/jquery.fancybox.css';
import 'bootstrap/dist/js/bootstrap.bundle';

import { Fancybox } from "@fancyapps/ui";


var arrowLeft = require('svg-inline-loader?classPrefix!../img/arrow-left.svg');
var arrowRight = require('svg-inline-loader?classPrefix!../img/arrow-right.svg');





const numberOfSlide = 4;

class MLC {

	loup;
	animating;
	currentSlide;


	constructor() {

		this.loup = new MLC3D();
		this.loup.animate();

		this.animating = true;
		this.currentSlide = 1;

		var that = this;

		document.addEventListener('Lunch', function(e) {
			gsap.to('#section-1 .h2', {opacity: 1, duration: .5, delay: .5, onComplete: function(){
				gsap.set('#section-1 .paragraphe', {opacity: 1});
				that.displayText( 0 );
				that.animating = false;
			}});
			
		});


		$('#side-nav .nav-item').click(function(e){

			var nextSection = $(this).data('section');

			if (that.currentSlide != nextSection) {
				that.currentSlide = nextSection;
				that.updateSlider();
			}

		});


		$('.imgages-mobile a').click(function(){

			var projectID = $(this).data('project-id');

			var galerie = i18n.projects[projectID].galerie_mobile;

			var objects = [];

			for (var obj of galerie) {

				objects.push({
					src : obj['url']
				});

			}

			$.fancybox.open( objects );

		});

		$('.scroll-down').click(function(e) {
			e.preventDefault();

			if (!that.animating) {
				that.currentSlide = 2;
				that.updateSlider();
			}

		});

		window.addEventListener('resize', () => {
			this.refreshVH();
		});

		this.refreshVH();

		this.initNavigation();		

		$('.slider-image').slick({
			autoplay: true,
			dots: true,
			arrows: false,
			fade: true,
			pauseOnFocus: false,
			pauseOnHover: false,
			speed: 1000,
			autoplaySpeed: 3000,
			rows: 0
		}).slick('slickFilter', '[data-project="0"]');

		$('.slider-projects').slick({
			autoplay: false,
			dots: false,
			arrows: true,
			fade: false,
			pauseOnFocus: false,
			pauseOnHover: false,
			speed: 1000,
			//prevArrow: '',
			//nextArrow: '<div class="btn btn-outline-primary btn-sm">Histoire suivante' + arrowRight + '</div>',
			prevArrow: '<div class="slick-prev">' + arrowLeft + '</div>',
			nextArrow: '<div class="slick-next">' + arrowRight + '</div>',
		}).on('beforeChange', function(event, slick, currentSlide, nextSlide){
			$('.slider-image').slick('slickUnfilter').slick('slickFilter', '[data-project="' + nextSlide + '"]').slick('slickGoTo', 0);
			gsap.from('.slider-image', {opacity: 0, duration: 1});
		});


		Fancybox.bind()


		//this.currentSlide = 3;
		//this.updateSlider();

	}


	refreshVH() {
		let vh = window.innerHeight * 0.01;
		document.documentElement.style.setProperty('--vh', `${vh}px`);
	}


	displayText( delay = .75 ) {

		var currentSection = $('#section-' + this.currentSlide);

		var paragraphe = currentSection.find('.paragraphe');

		if (paragraphe.length > 0) {

			var tl = gsap.timeline();

			tl.from(paragraphe, {duration: .5, opacity:0, y:50, ease:"back", delay: delay});

		}

		

	}


	initNavigation() {

		var $wrapper = $('#main');

		var that = this;

		$wrapper.bind('wheel', function(event, delta) {

			if (event.originalEvent.deltaY > 0 && !that.animating) {

				if ( (that.currentSlide + 1) <= numberOfSlide ) {
					that.currentSlide++;
					that.updateSlider();
				}
				
			} else if (event.originalEvent.deltaY < 0 && !that.animating) {
				if ( (that.currentSlide - 1) >= 1 ) {
					that.currentSlide--;
					that.updateSlider();
				}
			}

		});


		var swiper = new Swipe('#main');

		swiper.onUp(function() {

			if ( !that.animating) {
				if ( (that.currentSlide + 1) <= numberOfSlide ) {
					that.currentSlide++;
					that.updateSlider();
				}
			}

		});

		swiper.onDown(function() {

			if ( !that.animating) {

				if ( (that.currentSlide - 1) >= 1 ) {
					that.currentSlide--;
					that.updateSlider();
				}

			}

		});

		swiper.run();

	}

	updateSlider() {

		this.animating = true;
		var that = this;


		$('#side-nav .nav-item').removeClass('active');
		$('#side-nav .nav-item[data-section="' + this.currentSlide + '"]').addClass('active');


		$('.section').removeClass('active').removeClass('before');


		for (var i=1; i < this.currentSlide; i++) {
			$('#section-' + i).addClass('before');
		}

		if ( this.currentSlide == 3 ) {
			$('#slider-wrapper .slide-outer').addClass('active');
			$('.slider-image').slick('slickGoTo', 0);
		} else {
			$('#slider-wrapper .slide-outer').removeClass('active');
		}

		$('#section-' + this.currentSlide).addClass('active');

		this.displayText();

		this.loup.goToSlide (this.currentSlide);

		$('body').removeClass (function (index, className) {
		    return (className.match (/(^|\s)section-\S+/g) || []).join(' ');
		}).addClass('section-' + this.currentSlide).delay(1200).queue(function() {
            that.animating = false;
        	$(this).dequeue();
        });

	}


}


var mlc= new MLC();